import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { StandardTestResultsMainModule } from './standard-test-results/standard-test-results-main.module';
import { MicrobiologyDataModule } from './microbiology-data/microbiology.module';
import { TestResultAgRendererComponent } from './test-result-ag-renderer.component';
import { OnScreenResultsRenderer } from './on-screen-results-renderer';
import {OsrSubjectColumnRendererComponent} from './standard-test-results/osr-subject-columns-renderer.component';

@NgModule({
    imports: [
        SharedModule,
        StandardTestResultsMainModule,
        MicrobiologyDataModule
    ],
    declarations: [
        TestResultAgRendererComponent,
        OsrSubjectColumnRendererComponent,
    ],
    entryComponents: [
        TestResultAgRendererComponent,
        OsrSubjectColumnRendererComponent
    ],
    providers: [
        OnScreenResultsRenderer
    ]
})
export class OnScreenResultsModule { }